import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";

import { useDispatch, useSelector } from "react-redux";
import { ProductMasterTab } from "./ProductMasterTab";
import {
  fetchColorMaster,
  fetchColorMaster2,
  fetchModelMaster,
  fetchModelMaster2,
  setPermissionColor,
  setPermissionModel,
  setPermissionProduct,
} from "./ProductRelatedSlice";
import { selectPagination } from "../../modules/Auth/_redux/authRedux";
import { ModelMasterTab } from "./ModelMasterTab";
import { ColorMasterTab } from "./ColorMasterTab";
import { useLocation } from "react-router-dom";
import { fetchMenuTab, selectMenuTab } from "../menu/menuSlice";
import { checkMenu } from "../../utility";

export const ProductRelatedPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [active, setActive] = useState("");
  const paginationSet = useSelector(selectPagination);
  const dataMenuTab = useSelector(selectMenuTab);
  const [list, setList] = useState(null);

  console.log(location.pathname, "location");

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(
        fetchMenuTab({
          menu_url: "/master/product-related",
        })
      );
      await dispatch(
        fetchColorMaster2({
          is_enable: "Y",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
      await dispatch(
        fetchModelMaster2({
          is_enable: "Y",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataMenuTab.length > 0) {
      const data = dataMenuTab.map((item) => item.menu_name);
      setList(data);
      setActive(data[0]);

      const master = dataMenuTab.map((item, index) => {
        if (item.menu_name === "Product Master") {
          return dispatch(setPermissionProduct(item.permissions));
        }
        if (item.menu_name === "Model Master") {
          return dispatch(setPermissionModel(item.permissions));
        }
        if (item.menu_name === "Color Master") {
          return dispatch(setPermissionColor(item.permissions));
        }
      });
    }
  }, [dataMenuTab]);

  return (
    <>
      {list && (
        <div>
          <Tabs id="uncontrolled-tab-example" onSelect={(e) => setActive(e)}>
            {checkMenu(list, "Product Master") && (
              <Tab eventKey="Product Master" title="Product Master">
                <ProductMasterTab />
              </Tab>
            )}

            {checkMenu(list, "Model Master") && (
              <Tab eventKey="Model Master" title="Model Master">
                <ModelMasterTab />
              </Tab>
            )}

            {checkMenu(list, "Color Master") && (
              <Tab eventKey="Color Master" title="Color Master">
                <ColorMasterTab />
              </Tab>
            )}
          </Tabs>
        </div>
      )}
    </>
  );
};
